// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  ProductDetail,
  SearchProduct,
} from './';

export default {
  path: '',
  name: 'Gkproduct',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'ProductDetail', name: 'Product detail', component: ProductDetail },
    { path: 'SearchProduct/:id', name: 'Search product', component: SearchProduct },
  ],
};



// WEBPACK FOOTER //
// ./src/features/gkproduct/route.js